import { z } from "zod";

import { preProcessToInt } from "./preProcessToInt";

export const ShadeSchema = z.preprocess(
    preProcessToInt,
    z.union([z.literal(40), z.literal(70), z.literal(100), z.literal(400), z.literal(700)])
);
